<template>
  <div class="investment-reg__card-body">
    <div class="investment-reg__card-header">Отлично!</div>
    <div class="investment-reg__card-text">
      Теперь тебе предстоит пройти марафон вместе с Аязом, на котором ты будешь
      делать регулярные действия для привлечения инвестиций, которые в конечном
      итоге помогут тебе зайти на МсА.
    </div>
    <div class="investment-reg__card-text">
      На платформе тебя будут сопровождать регулярные встречи и разборы с
      экспертами, их можно пройти в курсе. Также на платформе для тебя создан
      контроль прогресса, где ты будешь еженедельно вносить ключевые метрики и
      отмечать выполненные действия! Удачи!
    </div>
    <div class="investment-reg__card-form">
      <UiButton class="fill-row" @click="finishRegistration()">
        Перейти в контроль прогресса
      </UiButton>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('ratingInvestmentsRegistration');

export default {
  name: 'FinishPage',
  computed: {
    ...mapState({
      user: state => state.data.localUser
    })
  },
  methods: {
    finishRegistration() {
      this.$store.dispatch('ratingInvestmentsRegistration/finishRegistration');
      this.$router.push('/rating/unified/user/' + this.user.id);
    }
  }
};
</script>
